import InstitutionsListContainer from './components/List/InstitutionsListContainer';
import InstitutionsDetailsContainer from './components/Details/InstitutionsDetailsContainer';
// import SnackbarLastNews from './components/SnackbarLastNews';
import './assets/scss/main.css';

// export {NewsDetailsContainer, SnackbarLastNews};
export {InstitutionsDetailsContainer};
export default InstitutionsListContainer;


// WEBPACK FOOTER //
// ./src/features/Institutions/index.js